var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "category-filter"
  }, [_c('div', {
    staticClass: "filter-button",
    class: {
      active: _vm.value === null
    },
    on: {
      "click": function () {
        return _vm.$emit('input', null);
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "14",
      "viewBox": "0 0 16 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 2C0 0.90625 0.875 0 2 0H14C15.0938 0 16 0.90625 16 2V12C16 13.125 15.0938 14 14 14H2C0.875 14 0 13.125 0 12V2ZM6 4.25H14.5V2C14.5 1.75 14.25 1.5 14 1.5H6V4.25ZM4.5 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V4.25H4.5V1.5ZM1.5 5.75V8.25H4.5V5.75H1.5ZM1.5 9.75V12C1.5 12.2812 1.71875 12.5 2 12.5H4.5V9.75H1.5ZM6 12.5H14C14.25 12.5 14.5 12.2812 14.5 12V9.75H6V12.5ZM14.5 8.25V5.75H6V8.25H14.5Z",
      "fill": "currentColor"
    }
  })]), _c('span', {
    staticClass: "filter-label overline"
  }, [_vm._v(_vm._s(_vm.$t('blog.all_categories')))])]), _vm._l(_vm.categories, function (category) {
    return _c('div', {
      key: category.id,
      staticClass: "filter-button category-button",
      class: {
        active: _vm.value === category.id
      },
      on: {
        "click": function () {
          return _vm.$emit('input', category);
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "16",
        "height": "14",
        "viewBox": "0 0 16 14",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 2C0 0.90625 0.875 0 2 0H14C15.0938 0 16 0.90625 16 2V12C16 13.125 15.0938 14 14 14H2C0.875 14 0 13.125 0 12V2ZM6 4.25H14.5V2C14.5 1.75 14.25 1.5 14 1.5H6V4.25ZM4.5 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V4.25H4.5V1.5ZM1.5 5.75V8.25H4.5V5.75H1.5ZM1.5 9.75V12C1.5 12.2812 1.71875 12.5 2 12.5H4.5V9.75H1.5ZM6 12.5H14C14.25 12.5 14.5 12.2812 14.5 12V9.75H6V12.5ZM14.5 8.25V5.75H6V8.25H14.5Z",
        "fill": "#currentColor"
      }
    })]), _c('span', {
      staticClass: "filter-label overline"
    }, [_vm._v(_vm._s(category.details.title))])]);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }